import classNames from "classnames";
import React, { FC } from "react";

import HWLogo from "../../assets/images/HWLogo.svg";
import { useConfigContext } from "../../contexts/ConfigContext/ConfigContext";
import { Image } from "../elements";
import "./Logo_wang.scss";

interface ILogoProps {
	"data-testid"?: string;
	className?: string;
}

const Logo: FC<ILogoProps> = (props) => {
	const { state: location } = useConfigContext((state) => state.location);

	return (
		<div
			data-testid={props["data-testid"] ?? "HWLogoCntr"}
			className={classNames("LogoCntr", props.className)}
		>
			<Image src={HWLogo} alt="Company Logo" className="Logo" />
			{location && <div className="LogoText">{location?.name}</div>}
		</div>
	);
};

export default React.memo(Logo);
